import { render, staticRenderFns } from "./BankAccountEdit.vue?vue&type=template&id=766704aa&scoped=true&"
import script from "./BankAccountEdit.vue?vue&type=script&lang=js&"
export * from "./BankAccountEdit.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountEdit.vue?vue&type=style&index=0&id=766704aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766704aa",
  null
  
)

export default component.exports